import React from "react";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";
import { Card, Row, Col } from "antd";
import Layout from "../components/TheLayout";
import { HTMLContent } from "../components/Content";
import PublicationsList from "../components/PublicationsList";
const ResearchTheme = ({ data }) => {
  const { markdownRemark: post } = data;
  return (
    <Layout>
      <Helmet titleTemplate="%s | OrgBioChem">
        <title>{`${post.frontmatter.title}`}</title>
      </Helmet>
      <Row>
        <Col md={{ span: 16, offset: 4 }}>
          <Card
            actions={[<Link to="/research">Back to research</Link>]}
            title={post.frontmatter.title}
            style={{ margin: "12px" }}
            bordered={false}
          >
            <div style={{ paddingBottom: "24px" }}>
              <HTMLContent content={post.html} />
            </div>

            <div style={{ paddingTop: "24px", borderTop: "1px solid #d3d3d3" }}>
              <h3 style={{ margin: "12px auto", color: "grey" }}>
                Selected references
              </h3>
              <div>
                <PublicationsList
                  publications={post.frontmatter.publications}
                />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};

export default ResearchTheme;

export const pageQuery = graphql`
  query ResearchThemeByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        image {
          childImageSharp {
            fixed(width: 300) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        title
        publications {
          title
          authors
          journal
          link
        }
      }
    }
  }
`;
